export const INIT_STORESDETAILS = 'store/storeDetails/INIT_STORESDETAILS'
export const SET_SORT_PARAMS = 'store/storeDetails/SET_SORT_PARAMS'
export const INIT_STORES_VIEW_DETAILS = 'store/storeDetails/INIT_STORES_VIEW_DETAILS'
export const ADMIN_STORESDETAILS = 'store/storeDetails/ADMIN_STORESDETAILS'
export const PAGINATION_STORESDETAILS = 'store/storeDetails/PAGINATION_STORESDETAILS'
export const SET_SEARCH_PARAMS_STORES = 'store/storeDetails/SET_SEARCH_PARAMS_STORES'
export const GET_DEVICEUPGRADE = 'store/storeDetails/GET_DEVICEUPGRADE'



// WEBPACK FOOTER //
// ./src/actionTypes/StoreDetails/storeDetails.js